import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e31b60"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "input-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "input-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "content-inner",
            style: _normalizeStyle({
          height: `calc(100% - ${_ctx.keyBoardHeight || 0}px)`,
        })
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({
            wrap: true,
            'wrap--keyboard-open': _ctx.keyboardOpen,
            'wrap--keyboard-open-android': _ctx.isAndroid,
          })
            }, [
              _createElementVNode("img", {
                src: require('@/assets/images/magic-trick-dynamic-color.png')
              }, null, 8, _hoisted_1),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t("login-page.title")), 1),
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.t("login-page.no-more-passwords-subtitle")) + " ", 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.t("login-page.get-magic-link-subtitle")), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  class: "loopin-input",
                  placeholder: "Email",
                  inputmode: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              (!_ctx.magicLinkLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      class: "loopin-input",
                      placeholder: "Password",
                      type: "password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.form.password]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_button, {
                mode: "ios",
                class: "loopin-button loopin-button--gradient",
                size: "large",
                expand: "block",
                disabled: _ctx.loginInProgress,
                onClick: _ctx.login
              }, {
                default: _withCtx(() => [
                  (_ctx.loginInProgress)
                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                        key: 0,
                        name: "lines"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.t("login-page.receive-magic-link")), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ], 2)
          ], 4)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}